import React from "react";
import {
  Flex,
  FormikField,
  HStack,
  LinkText,
  PrimaryButton,
  Text,
} from "flicket-ui";
import { Formik } from "formik";
import { AnimatePresence, motion } from "framer-motion";

import { getFormValues, validationSchema } from "~form/login";

type LoginFormProps = {
  formType: "link" | "password";
  handleSubmit: (actions: any, values: any) => void;
  showForgotPassword?: boolean;
};

export const LoginForm = ({
  handleSubmit,
  formType,
  showForgotPassword = true,
}: LoginFormProps) => {
  return (
    <Formik
      initialValues={getFormValues({}, formType)}
      validationSchema={validationSchema(formType)}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({ handleSubmit, isSubmitting, submitCount }) => (
        <Flex
          as="form"
          onSubmit={handleSubmit}
          maxWidth={{ default: "100%", sm: 380 }}
          flexDirection="column"
          role="form"
        >
          <FormikField
            label="Email"
            name="email"
            type="email"
            mb={3}
            submitCount={submitCount}
          />
          <AnimatePresence>
            {formType === "password" && (
              <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{
                  opacity: 0,
                  height: 0,
                  // Make the opacity exit transition faster so the submit button
                  // doesn't overlap it.
                  transition: { opacity: { duration: 0.1 } },
                }}
                style={{ width: "100%" }}
              >
                <FormikField
                  label={
                    (
                      <HStack justifyContent="space-between">
                        Password
                        {showForgotPassword && (
                          <Text variant="small" alignSelf="center">
                            <LinkText href="/forgot-password">
                              Forgot password?
                            </LinkText>
                          </Text>
                        )}
                      </HStack> // Label can take a ReactNode but we need to fool the type system
                    ) as unknown as string
                  }
                  name="password"
                  type="password"
                  mb={4}
                  submitCount={submitCount}
                />
              </motion.div>
            )}
          </AnimatePresence>
          <PrimaryButton type="submit" isLoading={isSubmitting} width="100%">
            {formType === "link" ? "Send link" : "Log in"}
          </PrimaryButton>
        </Flex>
      )}
    </Formik>
  );
};

export function CreateAccountLink() {
  return (
    <Text variant="small">
      No account yet?{" "}
      <LinkText href="/signup" color="P300">
        Create account
      </LinkText>
    </Text>
  );
}
